import { apiDaInscricao } from "../../../servicos/axios";

export const bloquearCidade = async (id: number): Promise<void> => {
  await apiDaInscricao().put(`/permissaoDasCidades/${id}/bloquear`);
};
